import { HOME_URL } from "./homeUrl";

export const FAVICON_LINKS = [
  { rel: "manifest", href: `${HOME_URL}/img/favicons/manifest.json` },
  { rel: "icon", href: `${HOME_URL}/img/favicons/favicon.ico` },
  {
    rel: "apple-touch-icon",
    sizes: "180x180",
    href: `${HOME_URL}/img/favicons/apple-touch-icon.png`,
  },
  {
    rel: "icon",
    type: "image/png",
    sizes: "32x32",
    href: `${HOME_URL}/img/favicons/favicon-32x32.png`,
  },
  {
    rel: "icon",
    type: "image/png",
    sizes: "16x16",
    href: `${HOME_URL}/img/favicons/favicon-16x16.png`,
  },
];
